import React, { useEffect, useState } from 'react'
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { stepLabelClasses } from '@mui/material/StepLabel';
import { Body, Micro } from '@vds/typography';
import styled from 'styled-components';
import './VZStepper.css'
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { getActiveStep, getCompletedSteps } from './VZStepperGetSteps';

const ConnectorWrapper = styled(StepConnector)({
  [`&.${stepLabelClasses.labelContainer}`]: {
    textAlign: 'start'
  },
  [`&.${stepLabelClasses.active}`]: {
    [`&.${stepLabelClasses.label}`]: {
    display: 'contents',
    alignItems: 'flex-start',
    textAlign: 'start'
    },
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#008331',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#008331',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: '#eaeaf0',
    borderTopWidth: '3px',
    borderRadius: '1px',
   
  },
});

const StepperContainer = styled(Stepper)`
  display: flex;
  flex-direction: row;
  alignItems: flex-start;
  .MuiStepLabel-labelContainer{
  position:relative;
  top:-55px;
  }
  .MuiStepConnector-alternativeLabel{
  top:11px;
  left: calc(-95% + 16px);
  right: calc(90% + 16px);
  align-items: flex-start;
  margin-left:auto;
  justify-content:flex-end;
  }
  .MuiStepLabel-iconContainer{
  z-index:1;
  background-color:white;
  }
  @media screen and (max-width:1024px){
  .MuiStepLabel-horizontal{
  width:100% !important;
  }
  .MuiStepLabel-labelContainer{
  top:-55px;
  }
  }
  @media screen and (min-width:950px){
  .MuiStepConnector-alternativeLabel{
  right:${({stepsCount})=>stepsCount === 3 ? "calc(87% + 50px)" : stepsCount > 5 ? "calc(90% + 14px)" : "calc(90% + 22px)"};
  left:${({stepsCount})=>stepsCount === 3 ? "calc(-95% + -3px)":"calc(-95% + 8px)"};
  }
}
`;

const DivWrapper = styled.div`
width:${({stepsCount})=>stepsCount > 4 ? (100 + (41 - ((stepsCount*3) + (stepsCount - (6-stepsCount))))) : '130'}.4% !important;
@media screen and (max-width:767px){
width:${({stepsCount})=>((100 + (24 - ((stepsCount-1) * 3)))-0.4)}% !important;
}
`;

export const VZStepper = ({fromCustomize=false}) => {
  // const { t, ready } = useTranslation(["horizontal-progress-bar", "app"]);
  const [steps,setSteps] = useState(["Check availability","Select plan, router, & services","Review cart","Checkout"])
  let pathForDevices = {
    "foryoursmallbiz/internet":"Check availability",
    "foryoursmallbiz/internet/internet-services":"Check availability",
    "internet/customize-order":"Select plan, router, & services",
    "internet/checkout":"Checkout"
  }
  const completedIndex = {
    "foryoursmallbiz/internet":[],
    "foryoursmallbiz/internet/internet-services":[],
    "internet/customize-order":[0],
    "internet/checkout":[0,1]
  }
  useEffect(()=>{
    if(fromCustomize){
      let finalStep = ["Check availability","Select plan, router, & services","Checkout"]
      setSteps(finalStep)
    }

  },[fromCustomize])
  const CompletedIcon = (props) => {
    const { active, completed, className } = props;
    if (completed) {
      return (
        <div className='chck-mrk-outline'>
          <img src={`images/CheckMark.png`} alt="checkmark" width={'12px'} height={'7.95px'}/>
        </div>
      )
    }
    else {
      return <div style={{ position:'relative',top:'-1px',marginTop: '2px', width: '20px', height: '20px', borderRadius: '50%', border: active ? '2px solid #008331' : '2px solid #D8DADA' }}></div>
    }
  }
  
  const completedSteps = getCompletedSteps({completedIndex})
  const getActiveSteps = getActiveStep({steps,pathForDevices})
  const isInernetService = String(window.location.pathname).includes('foryoursmallbiz/internet/internet-services')
  return (
    <div className='vz-stepper-main-container'>
    {/* TODO: showUpperFunnelProgressBar - need to negate this flag */}
    <div className="full-width">
    <DivWrapper stepsCount={(steps && steps.length) ? steps.length : 0} className={(steps && steps.length ===3 ) ? 'vz-stpper-3' : 'vz-stpper-wdth'} style={{width:(steps && steps.length > 5) ? (((steps.length * 22) - (32 - (steps.length * 1.9)))+'%') :'121.5%', margin: 'auto',marginTop:'1rem'}}>
      <StepperContainer
        stepsCount = {(steps && steps.length) ? steps.length : 0}
        alternativeLabel={true}
        connector={<ConnectorWrapper />}
        orientation={'horizontal'}
        activeStep={getActiveSteps}>
        {(steps && steps instanceof Array) && steps.map((label, index) => {
          return(
          <Step key={label} completed={completedSteps.includes(index) ? true : false} className={(index === (getActiveSteps+1)) ? isInernetService  ?  'miui-stp-atv-grd-75' : 'miui-stp-atv-grd' : (index === (getActiveSteps)) ? 'miui-stp-atv-0' : ''} >
            <StepLabel StepIconComponent={CompletedIcon} style={{alignItems: 'flex-start', width: isMobile ? '40%' : ''}} >
              <div size="small" style={{display: 'flex', alignItems:'self-start'}} >
                <Micro size='small' >
                <div style={{fontWeight:(index === getActiveSteps) ? '700' : '100' }} className={(index === getActiveSteps) ? '' : 'showActive-sec'}>
                {label}
                </div>
                </Micro>
              </div>
            </StepLabel>
          </Step>
        )})}
      </StepperContainer>      
    </DivWrapper>
    </div>
    </div>
  )
}
